import { connect } from 'react-redux';
import AnnualFixedChargeInput from './AnnualFixedChargeInput';

import { setAFixedCharge } from '../../../common/utility/actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    aFixedCharge: state.utility.aFixedCharge,
    setAFixedCharge,
});

const combinedActions = {
    setAFixedCharge,
};

export default connect(
    mapStateToProps,
    combinedActions,
)(AnnualFixedChargeInput);



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/AnnualFixedChargeInput/index.js